import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type TextButtonProps = {
  hasIcon: boolean;
  variant?: 'rounded' | 'rounded-small';
};

const styles = ({ hasIcon, variant }: TextButtonProps) => {
  return [
    css`
      ${hasIcon
        ? `
            align-items: center;
            display: flex;
    
            svg {
              margin-right: ${theme.spacing(1)};
            }
          `
        : ''}

      background: transparent;
      border: 2px solid transparent;
      border-radius: 2px;
      color: ${theme.colors.neutral90};
      cursor: pointer;
      font-family: ${theme.font.family};
      font-size: ${theme.fontSize(14)};
      padding: ${theme.spacing(0.5, 1)};
      transition: background border-radius 250ms ease-out, border-color 250ms ease-out;

      :hover,
      :focus {
        background: ${!variant ? theme.colors.neutral5 : theme.colors.neutral20};
        border-color: ${!variant ? theme.colors.neutral5 : theme.colors.neutral20};
      }

      :focus {
        outline-color: ${theme.colors.primary50};
        outline-offset: 5px;
        outline-width: 2px;
      }

      :active {
        background: ${theme.colors.neutral10};
        border-color: ${theme.colors.neutral10};
        outline: none;
      }

      :disabled {
        background: transparent;
        border-color: transparent;
        color: ${theme.colors.neutral20};
        cursor: default;
      }
    `,
    variant === 'rounded' &&
      css`
        border-radius: ${theme.borderRadius.small};
        padding: ${theme.spacing(1)};
      `,
    variant === 'rounded-small' &&
      css`
        font-size: ${theme.fontSize(12)};
        border-radius: ${theme.borderRadius.small};
      `,
  ];
};

export const TextButtonStyles = {
  textButton: (textButtonProps: TextButtonProps) => styles(textButtonProps),
};
